export default function Blog() {
  return (
    <div>
      <h1>blog.title</h1>
      <p>blog.body</p>
    </div>
  );
}
